import { createContext, useContext } from "react";
import { PublicWebsiteResponse } from "../../models/WebsiteModels";

export const PublicSiteContext = createContext<PublicWebsiteResponse | null>(
  null,
);

export const usePublicSiteData = (): PublicWebsiteResponse | null =>
  useContext(PublicSiteContext);
